import cloneDeep from 'lodash/cloneDeep';
import { EXPENSE_STORE_ADMIN_CONST, EXPENSE_LANDING_CONST } from '../actionConstants';
import { ADMIN_SCREENS, ADMIN_SCREEN_TYPES, travelNExpConfig } from '../../expense/pages/ExpenseAdmin/adminConfig';

const INITIAL_STATE = {
	adminScreen: ADMIN_SCREENS.CATEGORIES_SCREEN,
	feature: 0,
	modalState: {
		activeModal: ''
	},
	unSavedScreenStatus: {
		[ADMIN_SCREENS.CATEGORIES_SCREEN]: false,
		[ADMIN_SCREENS.TRAVEL_AND_EXPENSE_SCREEN]: false,
		[ADMIN_SCREENS.POLICY_SCREEN]: false,
		[ADMIN_SCREENS.GENERATE_REPORTS]: false
	}
};

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}

	const { type, payload = {} } = action;
	switch (type) {
		case EXPENSE_STORE_ADMIN_CONST.ADMIN_SCREEN: {
			return {
				...state,
				adminScreen: payload
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.ADMIN_MODAL: {
			return {
				...state,
				...payload
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.ADMIN_CATEGORIES: {
			return {
				...state,
				[ADMIN_SCREEN_TYPES.CATEGORIES]: payload
			};
		}
		case EXPENSE_LANDING_CONST.EXPENSE_ERROR: {
			return {
				...state,
				[payload.screenType]: {
					...state[payload.screenType],
					'error': { ...payload }
				}
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.SCREEN_LEVEL_MODALS: {
			const { screenType, modalState } = payload;
			return {
				...state,
				[screenType]: {
					...state[screenType],
					modalState
				}
			};
		}
		case EXPENSE_LANDING_CONST.EXPENSE_LOADING: {
			return {
				...state,
				[payload.screenType]: {
					...state[payload.screenType],
					'loader': { ...payload }
				}
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.UNSAVED_SCREEN_STATUS: {
			return {
				...state,
				['unSavedScreenStatus']: {
					...state.unSavedScreenStatus,
					[payload.screenType]: payload.status
				}
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.CLEAR_STATE: {
			return {
				...state,
				[payload.screenType]: {}
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.T_N_E_DATA: {
			const formattedData = formatTNEData(payload.data);
			return {
				...state,
				[ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE]: { ...state.travelNExpense,
					tneData: formattedData }
			};
		}
		case EXPENSE_STORE_ADMIN_CONST.EXPNS_FEATURE_DATA: {
			const { feature } = payload;
			return {
				...state,
				feature
			};
		}
		default:
			return state;
	}
};

const formatTNEData = (data) => {
	const configData = cloneDeep(travelNExpConfig);
	for (let config of configData) {
		config.fieldData = data[config.getApiKey] || '';
	}
	return configData;
};
